import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { exportDealsMarked, exportInterestedUsers, InterestedUsers, showToast, usTimezone } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'

const Interesteduser = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [typeStatus, setTypeStatus] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [projectScope, setProjectScope] = useState("")
  const [amount, setAmount] = useState(0)

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const fetchInterestedUsers = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem("token");
        const limit = 10;
        const offset = page * limit;

        const response = await InterestedUsers({
          limit,
          offset,
          token,
        });

        setUsersList(response?.data?.data || []);

        if ((response?.data?.data.length || 0) < limit) {
          setTotalPages(page + 1);
        } else {
          setTotalPages(page + 2);
        }

      } catch (error) {
        console.error("Error fetching lenders:", error);
      } finally {
        setLoading(false)
      }
    };

    fetchInterestedUsers();
  }, [page]);



  const exportDeals = async () => {
    try {
      setLoading(true);
      const blobData = await exportInterestedUsers();
      // console.log(blobData, "blobData.......")
      if (blobData.size === 6506) {
        showToast("No data available for export.", "error");
        return;
      }

      const blob = new Blob([blobData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "interested_users.csv");
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message, "error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>Interested Lenders</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className=" row">
                          <h5 className="mb-0 w-auto">Interested Lenders</h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="Shows users who have shown interest in a project by initiating a chat. Operations can monitor investor engagement and help borrowers convert these interests into active funding."
                            data-tooltip-place="top"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div className="mt-3 mt-lg-0">

                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={exportDeals} ><span>Export</span></button>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Project Name</th>
                            <th>Project Type</th>
                            <th>User Name</th>
                            <th>User Email</th>
                            <th>City</th>
                            <th>Address</th>
                            <th>Interest shown at</th>
                          </tr>
                        </thead>
                        <tbody>
                          {usersList?.length > 0 ? (
                            usersList.map((project, index) => (
                              <tr key={index} style={{ height: '48px' }}>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{project?.project?.project_name || ''}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{project?.project?.type || ''}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{project?.user?.about?.name + ' ' + project?.user?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{project?.user?.about?.email || ''}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{project?.user?.about?.city || ''}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{project?.user?.about?.address || ''}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ marginTop: '5px' }}>
                                    <span>{usTimezone(project?.created_at)}</span>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
        </div>
      </div>
    </>

  )
}
export default Interesteduser;